@use '../../design-tokens/border-radius/border-radius' as *;
@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .root {
    @include border-radius-r1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
    border: none;

    &:disabled {
      cursor: default;
    }

    &.fullWidth {
      width: 100%;
    }

    // Sizes
    &.xsmall {
      @include typography-v2-ui-xs;
      min-width: 20px;
      height: 20px;
      padding: 6px 12px;
    }

    &.small {
      @include typography-v2-ui-sm;
      min-width: 32px;
      height: 32px;
      padding: 6px 12px;
    }

    &.medium {
      @include typography-v2-ui-sm;
      min-width: 36px;
      height: 36px;
      padding: 8px 12px;
    }

    &.large {
      @include typography-v2-ui-base;
      min-width: 40px;
      height: 40px;
      padding: 8px 12px;
    }

    &.xl {
      @include typography-v2-ui-base;
      min-width: 48px;
      height: 48px;
      padding: 12px;
    }

    &.xxl {
      @include typography-v2-ui-base;
      min-width: 60px;
      height: 60px;
      padding: 20px;
    }

    &.iconOnly {
      padding: 0;
    }

    // Variants
    &.primary {
      background-color: var(--action-primary-default);
      color: var(--text-on-primary);
      border: 1px solid transparent;

      svg {
        fill: var(--icon-on-primary);
      }

      &:hover {
        background-color: var(--action-primary-hover);
      }

      &:focus-visible {
        outline: 2px solid var(--border-focus);
        border: 1px solid var(--surface-default);
      }

      &:disabled {
        background-color: var(--action-primary-disabled);
        color: var(--text-disabled);

        svg {
          fill: var(--icon-disabled);
        }
      }
    }

    &.secondary {
      background-color: transparent;
      color: var(--text-primary);
      border: 1px solid var(--border-primary);

      svg {
        fill: var(--icon-primary);
      }

      &:hover {
        background-color: var(--action-primary-soft-hover);
        color: var(--text-primary);
      }

      &:focus-visible {
        outline: 2px solid var(--border-focus);
        border: 1px solid transparent;
      }

      &:disabled {
        border: 1px solid var(--border-disabled);
        background-color: transparent;
        color: var(--text-disabled);

        svg {
          fill: var(--icon-disabled);
        }
      }
    }

    &.tertiary {
      background-color: transparent;
      color: var(--text-default);
      border: 1px solid var(--border-default);

      svg {
        fill: var(--icon-default);
      }

      &:hover {
        background-color: var(--surface-hover);
        border: 1px solid var(--border-hover);
      }

      &:focus-visible {
        outline: 2px solid var(--border-focus);
        border: 1px solid transparent;
      }

      &:disabled {
        border: 1px solid var(--border-disabled);
        background-color: transparent;
        color: var(--text-disabled);

        svg {
          fill: var(--icon-disabled);
        }
      }
    }

    &.empty {
      color: var(--text-default);
      background-color: transparent;
      border: 1px solid transparent;

      svg {
        fill: var(--icon-default);
      }

      &:hover {
        background-color: var(--surface-hover);
      }

      &:focus-visible {
        outline: 2px solid var(--border-focus);
      }

      &:disabled {
        border: 1px solid var(--border-disabled);
        background-color: transparent;
        color: var(--text-disabled);

        svg {
          fill: var(--icon-disabled);
        }
      }
    }

    &.critical {
      background-color: var(--action-critical-default);
      color: var(--text-on-critical);
      border: 1px solid transparent;

      svg {
        fill: var(--icon-on-critical);
      }

      &:hover {
        background-color: var(--action-critical-hover);
      }

      &:focus-visible {
        outline: 2px solid var(--border-focus);
        border: 1px solid var(--surface-default);
      }

      &:disabled {
        background-color: var(--action-critical-disabled);
        color: var(--text-disabled);

        svg {
          fill: var(--icon-disabled);
        }
      }
    }
  }

  .label {
    display: flex;
    align-items: center;
    gap: 8px;

    &.reversed {
      flex-direction: row-reverse;
    }
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text {
    color: inherit;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }

  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid currentColor;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1.5s linear infinite;
  }
}
